// src/services/storage.js
const AUTH_TOKEN_KEY = "authToken";
const AUTH_DATA_KEY = "authData";

export const storage = {
  getToken: () => localStorage.getItem(AUTH_TOKEN_KEY),

  setToken: (token) => {
    const t = String(token ?? "").trim();
    if (t) localStorage.setItem(AUTH_TOKEN_KEY, t);
    else localStorage.removeItem(AUTH_TOKEN_KEY); // مهم: امسح لو فاضي
  },

  clearToken: () => {
    localStorage.removeItem(AUTH_TOKEN_KEY);
  },

  getAuthData: () => {
    const raw = localStorage.getItem(AUTH_DATA_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  },

  setAuthData: (data) => {
    if (data == null) localStorage.removeItem(AUTH_DATA_KEY);
    else localStorage.setItem(AUTH_DATA_KEY, JSON.stringify(data));
  },

  clear: () => {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(AUTH_DATA_KEY);
  },
};
